import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import useQuery from '../../utils/hook/useQuery';
import { Link, useHistory, useParams } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { closeTicketAction, getCatAction, getTicketAction, getTicketsCountAction, } from './actions';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectTicketList,
  makeSelectCatList,
} from './selectors';
import {
  Props,
  SelectorProps,
  Payload,

} from './interfaces';
import { Store } from '../../redux/reducers';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import TicketCards from '../../components/Cards/ticketCards';
import { Controller, useForm } from 'react-hook-form';
import { FileUploadTicketsRequestBuilder, ReplyAllTicketsRequestBuilder } from 'client-sdk/src/helpical/categories';
import handleNotfication from '../../utils/handleNotfication';
import Client from 'client-sdk/src/client';
import RonadIcons from '../../components/iconComponent';







const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      justifyContent: 'space-between'
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    uploadInput: {
      display: 'none',
    },
    choosebtn: {

      span: {
        'nth-child(1)': {
          backgroundColor: '#1976d2',
          color: '#fff',
        }
      }
    }

  })
);

const HelpicalDetails = props => {
  const params = useParams();
  const [openMsg, setOpenMsg] = useState(false);
  const [file, setFile] = useState<any>('');
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token') || '';
  const history = useHistory();
  const [isClose, setIsClose] = useState(false)



  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
    useForm({
      defaultValues: {
        file: null,
        subject: '1',
        msg: ''
      },
    });

  const classes = useStyles();
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'parentId.specified': false,
    'orderId.equals': params?.id,
  });



  useEffect(() => {
    props.getCatDispatch();

  }, []);

  useEffect(() => {
    getTicket();
    // setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getTicket = () => {
    props.ticketDispatch({
      id: params.id
    })
  }

  const handleClose = () => {
    props.closeTicketDispatch({
      payload: {
        id: params.id,
      }, callback: () => {
        getTicket();
      },
    })

  }

  const handleCloseModal = () => {
    setOpenMsg(false);
    setFile(null);
    setValue('file', null);

  }

  const onSubmit = async (data) => {
    try {

      setLoading(true);
      let fileData = new FormData();
      fileData.append("file", file);
      const makeRequest = new ReplyAllTicketsRequestBuilder()
        .params({

        })
        .data({
          id: props.match.params.id,
          message: data.msg,
          isReplyAndClose: false
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(
            response.data.id
          )
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      // history.push(`/orders/helpical/detail/${props.match.params.id}`);
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }


      handleError(err);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);

    }

  };
  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };

  const handleRemoveFile = () => {
    setFile(null)
    setValue('file', null);

  }

  const closeTicket = async (data) => {
    try {

      setLoading(true);
      let fileData = new FormData();
      fileData.append("file", file);
      const makeRequest = new ReplyAllTicketsRequestBuilder()
        .params({

        })
        .data({
          id: props.match.params.id,
          message: data.msg,
          isReplyAndClose: true
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(
            response.data.id
          )
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      // history.push(`/orders/helpical/detail/${props.match.params.id}`);
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }


      handleError(err);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);

    }
  }

  return (
    <React.Fragment>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              پیام‌های {params.id}
            </Typography>
            <div>

              <Button size='medium' variant='contained' color='primary' onClick={() => setOpenMsg(true)}
                style={{ marginLeft: '8px' }}>
                پاسخ به پیام
              </Button>
              <Button size='medium' variant='outlined' color='primary' onClick={handleClose} style={{ marginLeft: '150px' }}>
                بستن پیام
              </Button>
            </div>
          </div>
        </Paper>
      </Grid>
      <Grid container md={12} spacing={2} >
        {
          props.msgList.map(el => {
            return (

              <TicketCards data={el} />
            )

          })
        }
      </Grid>

      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth='lg'
        style={{ padding: '16px' }}

      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseModal ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
              >
                <RonadIcons name="times"  size={0.8}/>
              </IconButton>
            ) : null}
          </div>


          <Grid item xs={12} style={{ marginTop: '16px' }}>
            <p style={{ marginTop: '-8px', marginLeft: '46px' }}>

              پاسخ به پیام {props.match.params.id}
            </p>

          </Grid>
          <Divider style={{ width: '100%', marginTop: '16px' }} />
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent style={{ paddingTop: '8px' }}>

            <Controller
              style={{ width: '100%' }}
              control={control}
              name='subject'
              label='موضوع'
              rules={{ required: true }}
              as={
                <TextField
                  style={{ marginTop: '16px', marginBottom: '16px' }}
                  fullWidth
                  variant='outlined'
                  select
                >


                  <MenuItem
                    value={1}
                  >
                    {'پاسخ به پیام بر اساس دستبدی قبل'}
                  </MenuItem>


                </TextField>
              }
            />

            <Controller
              control={control}
              id='msg'
              name='msg'
              rules={{ required: true }}
              as={
                <TextField inputProps={{
                  style: {
                    height: '200px',
                    padding: '0 14px',
                  }
                }} margin='normal' multiline label='پیام خود را وارد کنید' variant='outlined' fullWidth />
              }
            />
            <Grid md={6}>
              <label htmlFor="file" className={classes.choosebtn} >
                <Button variant='contained' size='small' component="span" >
                  انتخاب فایل
                </Button>
                <input
                  id="file"
                  type="file"
                  name="file"
                  ref={register}
                  onChange={handleChangeFileInput}
                  className={classes.uploadInput}
                />
              </label>


            </Grid>
            {
              file &&
              <Grid style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
                <IconButton
                  aria-label="close"
                  style={{ marginLeft: 'auto' }}
                  onClick={handleRemoveFile}
                >
                  <RonadIcons name="times"  size={0.8}/>
                </IconButton>
                <span style={{ marginTop: '14px' }}>
                  <span style={{ fontWeight: 'bold' }} > {file.name} </span>
                  <span>( {file.size} KB )</span>
                </span>
              </Grid>
            }

            <Divider style={{ width: '100%', marginTop: '16px' }} />
          </DialogContent>
          <DialogActions >
            <Grid
              container
              spacing={2}
              direction='row-reverse' style={{ marginBottom: '8px' }}
            >
              <Button
                type='submit'
                variant="contained"
                size="medium"
                color="primary"
                style={{ marginLeft: '24px' }}
              >
                {`ارسال پاسخ`}
              </Button>
              <Button
                onClick={handleSubmit(closeTicket)}
                variant="outlined"
                size="medium"
                color="primary"
                style={{ marginLeft: '24px' }}
              >
                {`ارسال پاسخ و بستن پیام`}
              </Button>

            </Grid>
          </DialogActions>
        </form>

      </Dialog>
    </React.Fragment >
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  catList: makeSelectCatList(),

  msgList: makeSelectTicketList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),

    ticketDispatch: (payload: Payload) => dispatch(getTicketAction(payload)),
    closeTicketDispatch: (payload: Payload) => dispatch(closeTicketAction(payload)),

  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(HelpicalDetails);
